import { render, staticRenderFns } from "./RipaRace.vue?vue&type=template&id=36e5cf84"
import script from "./RipaRace.vue?vue&type=script&lang=js"
export * from "./RipaRace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports